import React from 'react';

import { Image } from '../Image';

type LogoProps = {
  src: string;
  className?: string;
};

export const Logo: React.FC<LogoProps> = ({ src, className = '' }) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Image
        imageUrl={src}
        imageClassName="object-fit w-[14.5rem] h-[3.2rem]"
        className="shrink-0 w-[14.5rem] h-[3.2rem] overflow-hidden"
      />
    </div>
  );
};
